export function sortTree(tree) {
  const topLevelNodes = tree
    .filter((node) => node.parentId === null)
    .map((node) => ({
      ...node,
      name: node.categoryName,
      path: node.categoryName,
      // level: 0,
    }))
    .sort((a, b) => a.order - b.order);

  function sortChildren(node, level) {
    const children = tree
      .filter((child) => child.parentId === node.id)
      .map((c) => ({
        ...c,
        path: `${node.path} > ${c.categoryName}`,
        name: c.categoryName,
        // level,
      }));
    children.sort((a, b) => a.order - b.order);
    children.forEach((child) => {
      sortChildren(child, level + 1);
    });
    node.children = children;
  }

  topLevelNodes.forEach((node) => {
    sortChildren(node, 1);
  });

  function flatten(node) {
    const { children, ...rest } = node;
    return [rest].concat(children.flatMap(flatten));
  }

  return topLevelNodes.flatMap(flatten);
}
